<template>
  <div id="character-move-set-wrap">
    <h3 @click="showMoveset()">{{ moveTypeLocal }} Moves</h3>
    <p class="subnote" v-if="subtext">{{ subtext }}</p>
    <div class="moveset" v-show="movesetVisible">
      <CharacterMove v-for="move in moves" :key="move.title" :move="move" />
    </div>
  </div>
</template>
<script>
import CharacterMove from "./CharacterMove.vue";

export default {
  name: "CharacterMoveSet",
  props: ["moveset", "moveType", "movesetVisible", "subtext"],
  components: { CharacterMove },
  data() {
    return {
      moveTypeLocal: ""
    };
  },
  created() {
    this.moves = this.moveset;
    this.moveTypeLocal =
      this.moveType.charAt(0).toUpperCase() + this.moveType.slice(1);
  },
  methods: {
    showMoveset() {
      this.$emit("showMoveset");
    }
  }
};
</script>
<style lang="css">
#character-move-set-wrap {
  width: 90%;
}

#character-move-set-wrap h3 {
  width: 90%;
  margin-top: 0.5em;
  margin-bottom: 0;
  text-align: left;
}

#character-move-set-wrap > p {
  width: 90%;
  margin-top: 0;
  text-align: left;
}

.moveset {
  width: 90%;
  margin-left: 1em;
  text-align: left;
}
</style>